import { Link, useLocation } from "react-router-dom";
import { useState } from "react";

export default function SidebarAdmin() {
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);
  
  const handleLogout = () => {
    // Keep deviceId so trusted-device 2FA keeps working.
    localStorage.removeItem("token");
    localStorage.removeItem("role");
    localStorage.removeItem("userId");
    sessionStorage.clear(); // Clear CSRF and tab tenant session data
    window.location.href = "/login";
  };

  const menuItems = [
    { name: "Dashboard", path: "/admin/dashboard", icon: "📊" },
    { name: "Users", path: "/admin/users", icon: "👥" },
    { name: "WhatsApp Monitor", path: "/admin/sessions", icon: "📱" },
    { name: "Service Plans", path: "/admin/plans", icon: "💎" },
    { name: "Billing", path: "/admin/billing", icon: "💰" },
    { name: "Analytics", path: "/admin/analytics", icon: "📈" },
    { name: "API Keys", path: "/admin/api-keys", icon: "🔑" },
    { name: "Activity Logs", path: "/admin/logs", icon: "📋" },
    { name: "Reports", path: "/admin/reports", icon: "📄" },
    { name: "Settings", path: "/admin/settings", icon: "⚙️" },
  ];

  return (
    <>
      {/* Mobile menu button */}
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="lg:hidden fixed top-4 left-4 z-50 bg-gray-900 text-white p-2 rounded-lg"
      >
        ☰
      </button>

      {/* Sidebar */}
      <div className={`fixed lg:sticky top-0 left-0 w-64 bg-gray-900 h-screen text-white p-5 flex flex-col transition-transform duration-300 ease-in-out lg:translate-x-0 ${isOpen ? "translate-x-0" : "-translate-x-full"} z-40`}>
        <h2 className="text-2xl font-bold mb-8 text-blue-400">Admin Panel</h2>
        
        <nav className="flex flex-col gap-1 flex-1 overflow-y-auto">
          {menuItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              onClick={() => setIsOpen(false)}
              className={`flex items-center gap-3 p-3 rounded-lg transition ${
                location.pathname === item.path
                  ? "bg-blue-600 text-white"
                  : "hover:bg-gray-800 text-gray-300"
              }`}
            >
              <span>{item.icon}</span>
              <span className="text-sm font-medium">{item.name}</span>
            </Link>
          ))}
        </nav>

        <button 
          onClick={handleLogout}
          className="bg-red-600 hover:bg-red-700 p-3 rounded-lg font-bold transition mt-4 flex items-center justify-center gap-2 w-full"
        >
          🚪 Logout
        </button>
      </div>

      {/* Mobile overlay */}
      {isOpen && (
        <div
          className="lg:hidden fixed inset-0 bg-black opacity-50 z-30"
          onClick={() => setIsOpen(false)}
        />
      )}
    </>
  );
}
